export default "__VITE_ASSET__6bb7f1fa__"